import React, { Component } from 'react'
import UserHistoryList from 'components/organisms/user_history_list/tab'

class History extends Component{
    render(){
        return(
            <section className='p-4'>
                <h4 className='text-secondary my-4'>Historial</h4>
                <UserHistoryList/>
            </section>
        )
    }
}

export default History